import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { CCFTemplatesList } from './components/CCFTemplatesList';
import { ADMINS_CONSOLIDATED_CASHFLOW_TEMPLATES_PATH } from '../../../../utils/constants';

export const CCFTemplates = () => {
  return (
    <Switch>
      <Route
        exact
        path={ADMINS_CONSOLIDATED_CASHFLOW_TEMPLATES_PATH}
        component={CCFTemplatesList}
      />
    </Switch>
  );
};